(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dz-sale-products"] && !Shopify.designMode) return;
  try {
    

/* Shared once across product grids and all four builders.

 * Cart writes finish before this background read starts. Never repeat an add

 * because a header or drawer refresh failed, and never open a drawer here.

 */

if (!window.DazumaSaleCartSync) {

  window.DazumaSaleCartSync = {

    running: null,

    queued: false,

    cartUrl: '/cart',



    refresh(cartUrl) {

      this.cartUrl = cartUrl || '/cart';

      this.queued = true;

      if (this.running) return this.running;

      this.running = this.refreshQueued().finally(() => {

        this.running = null;

      });

      return this.running;

    },



    async refreshQueued() {

      do {

        this.queued = false;

        try {

          const response = await fetch(this.cartUrl + '.js', {

            method: 'GET',

            credentials: 'same-origin',

            cache: 'no-store',

            headers: { 'Accept': 'application/json' }

          });

          if (!response.ok) continue;

          const cart = await response.json();

          if (!Number.isInteger(cart.item_count)) continue;



          // Hyper's count method updates the badge without a cart-items event,

          // which would require rendered sections and could move keyboard focus.

          document.querySelectorAll('cart-count').forEach(counter => {

            if (typeof counter.onCartUpdate === 'function') {

              counter.onCartUpdate({ cart: cart });

            } else {

              counter.textContent = String(cart.item_count);

              counter.hidden = cart.item_count === 0;

            }

          });

          document.dispatchEvent(new CustomEvent('cart:updated', {

            detail: { cart: cart }

          }));



          // This is Hyper's native refresh event. open:false leaves the

          // shopper in place; Hyper fetches and replaces its drawer contents.

          document.dispatchEvent(new CustomEvent('cart:refresh', {

            detail: { open: false }

          }));

        } catch (error) {

          // The add was already confirmed. A read failure must not resubmit it.

          document.dispatchEvent(new CustomEvent('dz-sale:cart-refresh-error'));

        }

      } while (this.queued);

    }

  };

}



if (!customElements.get('dz-sale-product-add')) {

  customElements.define('dz-sale-product-add', class extends HTMLElement {

    connectedCallback() {

      if (this.initialized) return;

      this.initialized = true;

      this.button = this.querySelector('button');

      this.status = this.querySelector('[role="status"]');

      this.pending = false;

      this.uncertain = false;

      this.button.disabled = false;

      this.button.addEventListener('click', () => this.addProduct());

    }



    async addProduct() {

      if (this.pending || this.uncertain) return;

      const variantId = Number(this.dataset.variant);

      if (!Number.isSafeInteger(variantId) || variantId <= 0) return;

      this.pending = true;

      this.button.disabled = true;

      this.button.setAttribute('aria-busy', 'true');

      this.status.textContent = 'Adding…';

      const controller = new AbortController();

      const timeout = window.setTimeout(() => controller.abort(), 20000);

      try {

        const response = await fetch(this.dataset.addUrl, {

          method: 'POST',

          credentials: 'same-origin',

          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },

          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),

          signal: controller.signal

        });

        const result = await response.json();

        if (!response.ok || !Array.isArray(result.items) || !result.items.some(item => Number(item.variant_id || item.id) === variantId)) {

          throw new Error('The cart change could not be confirmed.');

        }

        this.status.textContent = 'Added to cart';

        window.DazumaSaleCartSync.refresh(this.dataset.cartUrl);

      } catch (error) {

        this.uncertain = true;

        this.status.textContent = 'Please check your cart before adding again. We could not confirm this change.';

      } finally {

        window.clearTimeout(timeout);

        this.pending = false;

        this.button.removeAttribute('aria-busy');

        this.button.disabled = this.uncertain;

      }

    }

  });

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dz-sale-set"] && !Shopify.designMode) return;
  try {
    
/* Shared once across product grids and all four builders.
 * Cart writes finish before this background read starts. Never repeat an add
 * because a header or drawer refresh failed, and never open a drawer here.
 */
if (!window.DazumaSaleCartSync) {
  window.DazumaSaleCartSync = {
    running: null,
    queued: false,
    cartUrl: '/cart',

    refresh(cartUrl) {
      this.cartUrl = cartUrl || '/cart';
      this.queued = true;
      if (this.running) return this.running;
      this.running = this.refreshQueued().finally(() => {
        this.running = null;
      });
      return this.running;
    },

    async refreshQueued() {
      do {
        this.queued = false;
        try {
          const response = await fetch(this.cartUrl + '.js', {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { 'Accept': 'application/json' }
          });
          if (!response.ok) continue;
          const cart = await response.json();
          if (!Number.isInteger(cart.item_count)) continue;

          // Hyper's count method updates the badge without a cart-items event,
          // which would require rendered sections and could move keyboard focus.
          document.querySelectorAll('cart-count').forEach(counter => {
            if (typeof counter.onCartUpdate === 'function') {
              counter.onCartUpdate({ cart: cart });
            } else {
              counter.textContent = String(cart.item_count);
              counter.hidden = cart.item_count === 0;
            }
          });
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: cart }
          }));

          // This is Hyper's native refresh event. open:false leaves the
          // shopper in place; Hyper fetches and replaces its drawer contents.
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            detail: { open: false }
          }));
        } catch (error) {
          // The add was already confirmed. A read failure must not resubmit it.
          document.dispatchEvent(new CustomEvent('dz-sale:cart-refresh-error'));
        }
      } while (this.queued);
    }
  };
}

/* One controller per section. A/B/C submit a complete fixed set, never nine products. */
if (!customElements.get('dz-fixed-sets')) {
  customElements.define('dz-fixed-sets', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        return;
      }
      this.initialized = true;
      this.pending = false;
      this.uncertain = false;
      this.tabs = Array.from(this.querySelectorAll('[data-tab-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.activeTab = 'a';
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: this.dataset.currency || 'USD'
      });

      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          this.activateTab(tab.dataset.tabTrigger, false);
        });
        tab.addEventListener('keydown', event => {
          const currentIndex = this.tabs.indexOf(tab);
          let nextIndex = currentIndex;
          if (event.key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % this.tabs.length;
          } else if (event.key === 'ArrowLeft') {
            nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = this.tabs.length - 1;
          } else {
            return;
          }
          event.preventDefault();
          this.activateTab(this.tabs[nextIndex].dataset.tabTrigger, true);
        });
      });

      this.panels.forEach(panel => {
        const button = panel.querySelector('[data-add]');
        if (button) {
          button.addEventListener('click', () => {
            this.addSet(panel.dataset.panel);
          });
        }
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-panel]');
        if (panel && this.contains(panel)) {
          this.activateTab(panel.dataset.panel, false);
        }
      });
      this.updateAll();
      this.activateTab('a', false);
    }

    activateTab(identifier, moveFocus) {
      const activePanel = this.panels.find(panel => panel.dataset.panel === identifier);
      if (!activePanel) {
        return;
      }
      this.activeTab = identifier;
      this.dataset.tab = identifier;
      this.tabs.forEach(tab => {
        const selected = tab.dataset.tabTrigger === identifier;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && moveFocus) {
          tab.focus();
        }
      });
      this.panels.forEach(panel => {
        panel.hidden = panel !== activePanel;
      });
      const badge = this.querySelector('[data-offer-badge]');
      const setDescription = this.querySelector('[data-set-description]');
      const customDescription = this.querySelector('[data-custom-description]');
      if (badge) {
        // D is navigation to a collection, not a fixed set with a promised discount.
        const selection = identifier === 'd' ? null : this.selection(activePanel);
        badge.hidden = identifier === 'd' || !selection.discountApplies;
      }
      if (setDescription) {
        setDescription.hidden = identifier === 'd';
      }
      if (customDescription) {
        customDescription.hidden = identifier !== 'd';
      }
    }

    selection(panel) {
      const cards = Array.from(panel.querySelectorAll('[data-set-item]'));
      const items = new Map();
      let complete = panel.dataset.panel !== 'd' && cards.length === 3;
      let allEligible = true;
      let subtotal = 0;
      let compareSubtotal = 0;

      cards.forEach(card => {
        const identifier = Number(card.dataset.variant);
        const quantity = Number(card.dataset.quantity);
        const price = Number(card.dataset.price);
        const comparePrice = Number(card.dataset.compare);
        const stock = Number(card.dataset.stock);
        const valid = Number.isSafeInteger(identifier) && identifier > 0 &&
          Number.isSafeInteger(quantity) && quantity >= 1 && quantity <= 99 &&
          Number.isSafeInteger(price) && price >= 0 &&
          Number.isSafeInteger(stock) && stock >= 0 &&
          card.dataset.available === 'true';
        if (!valid) {
          complete = false;
          return;
        }
        const existing = items.get(identifier);
        const combinedQuantity = quantity + (existing ? existing.quantity : 0);
        const availableStock = existing ? Math.min(existing.stock, stock) : stock;
        if (combinedQuantity > availableStock) {
          complete = false;
        }
        items.set(identifier, {
          id: identifier,
          quantity: combinedQuantity,
          stock: availableStock
        });
        subtotal += price * quantity;
        compareSubtotal += (Number.isSafeInteger(comparePrice) ? Math.max(price, comparePrice) : price) * quantity;
        if (card.dataset.eligible !== 'true') {
          allEligible = false;
        }
      });

      if (!Number.isSafeInteger(subtotal) || !Number.isSafeInteger(compareSubtotal)) {
        complete = false;
      }
      const rate = Number(this.dataset.rate);
      const code = (this.dataset.code || '').trim();
      const discountApplies = complete && allEligible && this.dataset.offer === 'true' &&
        code.length > 0 && Number.isFinite(rate) && rate > 0 && rate <= 100;
      const extraSaving = discountApplies ? Math.round(subtotal * rate / 100) : 0;
      return {
        complete: complete,
        discountApplies: discountApplies,
        subtotal: subtotal,
        originalTotal: compareSubtotal,
        extraSaving: extraSaving,
        total: subtotal - extraSaving,
        saleSaving: compareSubtotal - subtotal,
        totalSaving: compareSubtotal - subtotal + extraSaving,
        items: Array.from(items.values()).map(item => ({
          id: item.id,
          quantity: item.quantity
        }))
      };
    }

    updateAll() {
      this.panels.forEach(panel => {
        const button = panel.querySelector('[data-add]');
        if (!button) {
          return;
        }
        const selection = this.selection(panel);
        const values = {
          '[data-original-total]': selection.originalTotal,
          '[data-subtotal]': selection.subtotal,
          '[data-extra-saving]': selection.extraSaving,
          '[data-total]': selection.total,
          '[data-sale-saving]': selection.saleSaving,
          '[data-total-saving]': selection.totalSaving
        };
        Object.entries(values).forEach(([selector, value]) => {
          const output = panel.querySelector(selector);
          if (output) {
            const prefix = selector === '[data-extra-saving]' ? '−' : '';
            output.textContent = selection.complete ? prefix + this.money.format(value / 100) : '—';
          }
        });
        const originalRow = panel.querySelector('[data-original-row]');
        const finalLabel = panel.querySelector('[data-final-label]');
        if (originalRow) {
          originalRow.hidden = !selection.complete || selection.saleSaving <= 0;
        }
        if (finalLabel) {
          finalLabel.textContent = selection.discountApplies ? finalLabel.dataset.offerLabel : finalLabel.dataset.regularLabel;
        }
        const savingRow = panel.querySelector('[data-savings-row]');
        const codeNote = panel.querySelector('[data-code-note]');
        const breakdown = panel.querySelector('[data-breakdown]');
        if (savingRow) {
          savingRow.hidden = !selection.discountApplies;
        }
        if (codeNote) {
          codeNote.hidden = !selection.discountApplies;
        }
        if (breakdown) {
          breakdown.hidden = !selection.complete || selection.totalSaving <= 0;
        }
        button.disabled = this.pending || this.uncertain || !selection.complete;
        if (!selection.complete && !this.uncertain) {
          panel.querySelector('[data-status]').textContent = this.dataset.unavailable || 'This complete set is currently unavailable.';
        }
      });
    }

    async addSet(identifier) {
      if (this.pending || this.uncertain || identifier === 'd' || identifier !== this.activeTab) {
        return;
      }
      const panel = this.panels.find(candidate => candidate.dataset.panel === identifier);
      if (!panel) {
        return;
      }
      const selection = this.selection(panel);
      if (!selection.complete) {
        this.updateAll();
        return;
      }
      const button = panel.querySelector('[data-add]');
      const status = panel.querySelector('[data-status]');
      const cartLink = panel.querySelector('[data-check-cart]');
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(), 25000);
      this.pending = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = this.dataset.loading || 'Adding…';
      status.textContent = '';
      cartLink.hidden = true;
      this.updateAll();

      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: selection.items }),
          signal: controller.signal
        });
        const result = await response.json();
        if (!response.ok || !Array.isArray(result.items)) {
          throw new Error('The complete cart addition was not confirmed.');
        }
        const returnedIdentifiers = new Set(result.items.map(item => Number(item.variant_id || item.id)));
        if (!selection.items.every(item => returnedIdentifiers.has(item.id))) {
          throw new Error('Some set items were not confirmed.');
        }
        status.textContent = this.dataset.added || 'Set added to your cart.';
        if (selection.discountApplies) {
          status.textContent += ' Enter ' + this.dataset.code + ' at checkout for the extra savings.';
        }
        // Cart badge/drawer refresh happens after confirmation, without blocking
        // feedback or replaying the POST if the theme refresh is unavailable.
        Promise.resolve().then(() => {
          if (window.DazumaSaleCartSync) {
            return window.DazumaSaleCartSync.refresh(this.dataset.cartUrl);
          }
        }).catch(() => {
          document.dispatchEvent(new CustomEvent('dz-sale:cart-refresh-error'));
        });
      } catch (error) {
        // A failed or timed-out request may have changed the cart. Do not blindly
        // retry a batch and risk adding the same lights twice.
        this.uncertain = true;
        this.panels.forEach(candidate => {
          const candidateStatus = candidate.querySelector('[data-status]');
          const candidateLink = candidate.querySelector('[data-check-cart]');
          if (candidateStatus) {
            candidateStatus.textContent = 'We could not confirm the complete addition. Check your cart before trying again.';
          }
          if (candidateLink) {
            candidateLink.hidden = false;
          }
        });
      } finally {
        window.clearTimeout(timer);
        this.pending = false;
        button.setAttribute('aria-busy', 'false');
        button.textContent = this.dataset.ready || 'Add set to cart';
        this.updateAll();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dz-series-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dz-series-hero-title')) {
    customElements.define('dz-series-hero-title', class extends HTMLElement {
      connectedCallback() {
        this.heading = this.querySelector('h1');
        this.text = this.heading && this.heading.querySelector('span');
        if (!this.text) return;

        this.scheduleFit = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            if (this.isConnected) this.fitHeading();
          });
        };
        this.lastWidth = -1;
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver((entries) => {
            const width = entries[0].contentRect.width;
            if (Math.abs(width - this.lastWidth) > 0.1) {
              this.lastWidth = width;
              this.scheduleFit();
            }
          });
          this.resizeObserver.observe(this);
        }
        this.textObserver = new MutationObserver(this.scheduleFit);
        this.textObserver.observe(this.text, { childList: true, characterData: true, subtree: true });
        window.addEventListener('resize', this.scheduleFit, { passive: true });
        if (document.fonts) {
          document.fonts.ready.then(() => {
            if (this.isConnected) this.scheduleFit();
          });
          document.fonts.addEventListener('loadingdone', this.scheduleFit);
        }
        this.scheduleFit();
      }

      fitHeading() {
        // Reset first so the current desktop/mobile setting remains the maximum.
        this.heading.style.removeProperty('font-size');
        const maximumSize = parseFloat(getComputedStyle(this.heading).fontSize);
        const availableWidth = this.heading.getBoundingClientRect().width - 2;
        if (availableWidth <= 0 || !Number.isFinite(maximumSize)) return;
        const minimumSize = Math.min(18, maximumSize);

        // Measure actual theme typography, including letter spacing and loaded fonts.
        this.text.style.display = 'inline-block';
        this.text.style.whiteSpace = 'nowrap';
        let lower = minimumSize;
        let upper = maximumSize;
        if (this.text.getBoundingClientRect().width > availableWidth) {
          this.heading.style.fontSize = lower + 'px';
          if (this.text.getBoundingClientRect().width <= availableWidth) {
            for (let iteration = 0; iteration < 12; iteration += 1) {
              const candidate = (lower + upper) / 2;
              this.heading.style.fontSize = candidate + 'px';
              if (this.text.getBoundingClientRect().width <= availableWidth) {
                lower = candidate;
              } else {
                upper = candidate;
              }
            }
          }
          this.heading.style.fontSize = (Math.floor(lower * 100) / 100) + 'px';
        }
        // Extremely long titles wrap at the readable minimum; nothing is truncated.
        this.text.style.removeProperty('display');
        this.text.style.removeProperty('white-space');
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.textObserver) this.textObserver.disconnect();
        window.removeEventListener('resize', this.scheduleFit);
        if (document.fonts && this.scheduleFit) {
          document.fonts.removeEventListener('loadingdone', this.scheduleFit);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
